<template>
  <div id="myPosition">
    <div class="Grid5697DFBD" :style="backImg">
      <header :class="{isIos: 'iosHeight'}" class="headerArea">
        <nav>
          <md-icon name="arrow-left" size="lg" @click="goBack" />
        </nav>
        <h1>{{$t($route.meta.title)}}</h1>
        <div class="rightArea">
          <span class="span1" @click="toRecord">{{$t('label.label53')}}</span>
        </div>
      </header>
      <div class="Grid8E89CBF5">
        <div class="Grid2F851DB2">
          <div class="Grid0EE74B0B">
            <span :text="'总持仓（MOP）'" class="spanTop" v-if="haveData">{{$t('label.label54')}}（{{myPostionInfo.ccy}}）</span>
            <span :text="'总持仓（MOP）'" class="spanTop" v-if="!haveData">{{$t('label.label54')}}（MOP）</span>
            <span :text="'¥ 50,000.47'" class="spanBottom" v-if="haveData">{{$commafy(myPostionInfo.balance)}}</span>
            <span :text="'¥ 50,000.47'" class="spanBottom" v-if="!haveData">0.00</span>
          </div>
          <!-- <div class="Grid41B2B960">
            <span :text="'昨日收益'" class="spanTop">昨日收益</span>
            <span :text="'+5,57'" class="spanBottom"> +5,57</span>
          </div> -->
        </div>
        <div class="Grid0FB63652">
          <span :text="'累計收益：600.37'" class="textOfBottom" v-if="haveData">{{$t('label.label55')}}{{myPostionInfo.intTotal}}</span>
          <span :text="'累計收益：600.37'" class="textOfBottom" v-if="!haveData">{{$t('label.label55')}}0.00</span>
          <span class="textOfBottom textCenter">|</span>
          <span :text="'共三種存款'" class="textOfBottom" v-if="haveData">{{$t('label.label56')}}{{myPostionInfo.proTypeNum}}{{$t('label.label57')}}</span>
          <span :text="'共三種存款'" class="textOfBottom" v-if="!haveData">{{$t('label.label56')}}0{{$t('label.label57')}}</span>
          <!-- <span :text="'共三種存款'" class="textOfBottom"></span> -->
        </div>
      </div>
    </div>
    <div class="Grid903E8D77">
      <div class="GridB1ADBEE1" v-for="item in MyPositionList" :key="item.baseAcctNo" @click="goDetile(item)">
        <div class="Grid13505D99">
          <div :text="'月月高存款8000562214'" class="spanLeft">
            <p>{{item.prodName}}</p>
            <p>{{item.baseAcctNo}}</p>
          </div>
          <span :text="'2.38%'" class="spanRight">{{item.intRate}}%</span>
        </div>
        <div class="Grid286D60EC">
          <div class="GridB986D330">
            <span :text="'購買金額（MOP）'" class="spanTop">{{$t('label.label58')}}（{{item.ccy}}）</span>
            <span :text="'1222.00'"  class="spanBottom">{{$commafy(item.balance)}}</span>
          </div>
          <div class="Grid349E7A04">
            <span :text="'文本内容'" class="spanTop">{{$t('label.label59')}}（{{item.ccy}}）</span>
            <span :text="'48.99'" class="spanBottom">{{totalBalance(item)}}</span>
          </div>
        </div>
        <div class="Grid7A23714D" v-if="item.prodType !== 'FP01060005'">
          <span :text="'存期{{6}}個月  已存入15天  2021-04-30到期'" class="spanText">
            {{$t('label.label60')}}
            {{$setDepositTerm(item.depositTerm)}}
            {{$t('label.label61')}}
            {{item.proPayedDates}}
            {{$t('label.label62')}}
            {{item.acctMaturityDate}}
            {{$t('label.label63')}}</span>
        </div>
        <div class="Grid7A23714D" v-else>
          <span :text="'存期{{6}}個月  已存入15天  2021-04-30到期'" class="spanText">{{$t('label.label172')}}{{item.proPayedDates}}{{$t('label.label62')}}</span>
        </div>
      </div>
      <div v-if="!haveData&&isDataShow" class="noData">{{$t('label.label174')}}</div>
    </div>
  </div>
</template>
<script>
import { Icon } from '@gidc/mobile'
import { ACCONTINFOQUERY, MYPOSITIONINFO } from '../../api/smartdeposit'
import backImg from '../../assets/images/background.png'
import { mapGetters } from 'vuex'
export default {
  name: 'myPosition',
  components: {
    [Icon.name]: Icon
  },
  computed: {
    ...mapGetters([
      'RnInfo'
    ])
  },
  data () {
    return {
      backImg: {
        backgroundImage: 'url(' + backImg + ')',
        backgroundRepeat: 'no-repeat',
        backgroundSize: '100% 100%'
      },
      myPostionInfo: '',
      MyPositionList: [],
      haveData: false,
      isDataShow: false
    }
  },
  methods: {
    goDetile (item) {
      // FP01060001 零存整取智能存款
      // FP01060005 日日赚
      // FP01060002 月月高
      // FP01060004 天天金
      // FP01060006 智能存款定期
      console.log(item)
      this.$store.commit('proInfoDetails', item)
      console.log(item.prodClass)
      switch (item.prodClass) {
        case 'FP100': {
          this.$router.push({ name: 'accountInformationOfPerMonth' })
          break
        }
        case 'FP101': {
          this.$router.push({ name: 'accountInformationOfCurrent' })
          break
        }
        case 'FP102': {
          this.$router.push({ name: 'accountInformationOfMonth' })
          break
        }
        case 'FP103': {
          this.$router.push({ name: 'accountInformationOfDay' })
          break
        }
        case 'FP104': {
          this.$router.push({ name: 'accountInformationOfRegular' })
          break
        }
        default:
          break
      }
    },
    totalBalance (obj) {
      if (obj.prodClass !== 'FP100') {
        return this.$commafy((Number(obj.intTotal) + Number(obj.balance)).toString())
      } else {
        return this.$commafy((Number(obj.intTotal) + Number(obj.balance) + Number(obj.agreementAmt) * Number(obj.depositTerm.substr(1))).toString())
      }
    },
    getMyPositionInfo () {
      const params = {}
      this.$remote.post(MYPOSITIONINFO + '?_locale=' + this.$exchangeLang(this.RnInfo.language), params, { headers: { _token_name: this.RnInfo.token, 'x-i18n': this.$exchangeLang(this.RnInfo.language) } })
        .then(res => {
          this.myPostionInfo = res
          this.getMyPosition()
        })
    },
    getMyPosition () {
      const params = {
        serviceCode: 'MBSD_BP_FP', // 服务领域MBSD_BP_FP
        messageType: '1400', // 服务类型
        messageCode: '0103', // 服务编码
        baseAcctNo: '', // 理财账户
        linkedBaseAcctNo: '', // 购买账户
        prodType: '', // 产品类型
        documentType: '', // 证件类型
        documentId: '', // 证件号码
        startDate: '', // 查询开始时间
        endDate: '' // 查询结束时间
      }
      this.$remote.post(ACCONTINFOQUERY + '?_locale=' + this.$exchangeLang(this.RnInfo.language), params, { headers: { _token_name: this.RnInfo.token, 'x-i18n': this.$exchangeLang(this.RnInfo.language) } })
        .then(res => {
          this.MyPositionList = res.list
          this.isDataShow = true
          if (res.list.length > 0) {
            this.haveData = true
          } else {
            this.haveData = false
          }
        })
    },
    goBack () {
      this.$router.push(this.$route.meta.backPath || 'homePage')
    },
    toRecord () {
      this.$router.push('tradingRecord')
    }
  },
  created () {
    this.getMyPositionInfo()
    if (this.$route.params.path) {
      this.$route.meta.backPath = this.$route.params.path
    }
  },
  mounted () {

  }
}
</script>
<style lang="stylus" scoped>
  #myPosition{
    font-size .28rem
    .Grid5697DFBD{
      width 100vw
      position relative
      overflow hidden
      .headerArea{
        width 100vw
        height .88rem
        display flex
        align-items center
        position sticky
        top 0
        z-index 10000
        justify-content space-between
        nav{
          height .66rem
          width .66rem
          display flex
          align-items center
          justify-content center
          color #ffffff
        }
        h1 {
          font-size .34rem
          color #ffffff
          text-align center
          position absolute
          top 50%
          left 50%
          transform translate(-50%, -50%)
        }
        .rightArea{
          width 1.5rem
          height .88rem
          position relative
        }
        .span1{
          font-size .28rem
          color #ffffff
          white-space nowrap
          position absolute
          top 50%
          left 50%
          transform translate(-50%,-50%)
        }
      }
      .iosHeight{
        height 1rem
      }
      .Grid8E89CBF5{
        padding .3rem .54rem 0
        .Grid2F851DB2{
          display flex
          flex-direction row
          padding-bottom .34rem
          .Grid0EE74B0B{
            flex auto
            display flex
            flex-direction column
            text-align left
            .spanTop{
              display block
              height .4rem
              font-size .28rem
              font-weight 500
              color #FFFFFF
              line-height .4rem
            }
            .spanBottom{
              display block
              height .66rem
              font-size .56rem
              font-weight bold
              color #FFFFFF
              line-height .66rem
              padding-top: .09rem
            }
          }
          .Grid41B2B960{
            flex 1
            display flex
            flex-direction column
            .spanTop{
              text-align right
              display block
              height .4rem
              font-size .28rem
              font-weight 500
              color #FFFFFF
              line-height .4rem
            }
            .spanBottom{
              text-align right
              display block
              height .66rem
              font-size .56rem
              font-weight bold
              color #FFFFFF
              line-height .66rem
              padding-top .09rem
            }

          }
        }
        .Grid0FB63652{
          padding-bottom .74rem
          .textOfBottom{
            height .40rem
            font-size .28rem
            font-weight 400
            color #FFFFFF
            line-height .40rem
          }
          .textCenter{
            padding 0 .1rem
          }
        }
      }
    }
    .Grid5697DFBD::after{
      content ''
      width 100vw
      height .45rem
      background-color #ffffff
      position absolute
      left 0
      bottom 0
      border-radius .43rem .43rem 0 0
    }
    .Grid903E8D77{
      margin-top -.1rem
      padding 0 .3rem .3rem
      height calc(100vh - 4rem)
      position relative
      overflow auto
      .GridB1ADBEE1{
        padding .21rem 0 .28rem .12rem
        box-shadow 0 .04rem 026rem 0 rgba(126, 158, 255, 0.08)
        .Grid13505D99{
          display flex
          justify-content space-between
          align-items center
          padding-bottom .25rem
          .spanLeft{
            font-size .28rem
            font-weight 500
            color #1679FF
            line-height .4rem
          }
          .spanRight{
            height .58rem
            font-size .5rem
            font-weight bold
            color #FF5B58
            line-height .58rem
          }
        }
        .Grid286D60EC{
          display flex
          justify-content space-between
          align-items center
          padding-bottom .17rem
          .GridB986D330{
            display flex
            flex-direction column
            .spanTop{
              font-size .22rem
              font-weight 400
              color #999999
              line-height .30rem
              padding-bottom .03rem
            }
            .spanBottom{
              height .40rem
              font-size .28rem
              font-weight 500
              color #333333
              line-height .40rem
            }
          }
          .Grid349E7A04{
            display flex
            flex-direction column
            .spanTop{
              font-size .22rem
              font-weight 400
              color #999999
              line-height .30rem
              padding-bottom .03rem
            }
            .spanBottom{
              height .40rem
              font-size .28rem
              font-weight 500
              color #333333
              line-height .40rem
            }
          }

        }
        .Grid7A23714D{
          height .4rem
          border-radius .04rem
          opacity 0.42
          .spanText{
            display inline-block
            background #ECECEC
            font-size .2rem
            font-weight 400
            color #2F2F2F
            line-height .28rem
            padding .06rem .21rem .06rem .15rem
            word-wrap break-spaces
            text-align left
          }
        }
      }
      .GridB1ADBEE1+.GridB1ADBEE1{
        margin-top .3rem
      }
      .noData{
        position absolute
        left 50%
        top 45%
        transform translate(-50%,-50%)
      }
    }
  }
</style>
